<script setup>
import { getActivePinia } from "pinia"
import { useAuthStore } from '@core/stores/AuthStore'
import { useRouter } from 'vue-router'

const router = useRouter()

definePage({
  meta: {
    layout: 'blank',
    authenticatedOnly: true,
  },
})


onMounted( async () => {
  const authStore = useAuthStore()
  try {
    await authStore.logout()
  } catch (error) {
    console.trace('Error during logout', error)
  }

  // Reset all stores that support $reset
  getActivePinia()._s.forEach(store => {
    if (typeof store.$reset === 'function' && store.$state) {
      try {
        store.$reset()
      } catch (error) {
        console.warn(`Failed to reset store ${store.$id}:`, error)
      }
    }
  })

  router.push('/')
})
</script>


<template>
  <div />
</template>
